import { css } from 'lit';


export const globalStyleOnDark = css`
figcaption {
    --_figcaption__color: var(--sbkFigcaptionColorOnDarkDefault);
  }
` 
